import React from 'react'
import "../styles/About.scss";
import { BrowserRouter as Router, NavLink } from 'react-router-dom';

function About() {
    return (
        <div className="about_main">
            <div className="about_description">
                <h1 className='about_title'>Python Full Stack Web Developer</h1>
                <p>Приветствую! Я – кандидат на позицию Junior Python Full Stack Web Developer. Я закончил курс Fullstack
                разработчик на Python в SkillFactory. Меня привлекают задачи, которые могут быть решены с помощью Python и Django.</p>
                <br />
                <p>На курсе я успешно освоил язык Python, SQL, фреймворк Django, REST API, систему контроля версий GitHub,
                а также изучил Frontend технологии, такие как JavaScript, React, WebPack и Node.js. Я убедился в том,
                что Backend разработка - это то, что мне по душе. Мне очень нравится решать задачи связанные с разработкой
                логики и взаимодействием приложений.</p>
                <br />
                <p>В процессе обучения я создал несколько проектов, среди которых игры "крестики-нолики" и "морской бой".
                Они помогли мне набраться опыта в работе с функциями, циклами, условиями и другими базовыми элементами языка Python,
                а также с классами и декораторами функций, научился обрабатывать исключения. Интересно было работать над
                логикой ходов компьютера.</p>
                <br />
                <p>Дальнейшее изучение курса было связано с фреймворком Django. Я разработал "Новостной портал",
                что помогло мне лучше понять, как работают backend-приложения, реляционные базы данных (SQLite3, Postgres)
                и их взаимодействие через REST API.</p>
                <br />
                <p>В ходе обучения фронтенд технологиям я познакомился с React и на его базе создал несколько приложений.
                Столкнулся с проблемами асинхронного программирования и научился их решать, что является одним из самых
                сложных моментов.</p>
                <br />
                <p>На заключительном этапе обучения я изучал технологию Docker и научился создавать изолированное окружение
                для разных приложений и настраивать их взаимодействие с помощью Docker-compose. Я убедился, что это очень
                полезная и крутая технология, которая значительно упрощает разработку, локальное развертывание и deploy
                любых приложений</p>
                <br />
                <p>В текущий момент активно ищу работу. Я готов быстро создать требуемое окружение для разрабатываемых
                приложений и сервисов на основе технологии контейнеризации Docker, настроить backend-приложения на Django,
                REST API и Websocket, а также создать frontend-приложения на React с использованием Webpack и наладить их
                совместную работу с backend на Django. Портфолио с описанием моих проектов можно посмотреть в разделе
                <NavLink className="normal" to={'/projects'}> PROJECTS</NavLink>.</p>
                <br />
                <p><b>Soft skills:</b> Внимание к деталям с учетом требований заказчика, соблюдение стандартов кодирования,
                стремление к качественному выполнению заданий в рамках сроков, профессиональный рост и желание участвовать
                в сложных проектах.</p>
                <p><b>Hard skills:</b> Python, Django, REST, WebSocket, WebPack, React, TypeScript, Docker Compose, GitHub.</p>

                <hr />

                <p><b>Дополнительное образование:</b></p>
                <p>2023 | <b>Online school SkillFactory</b></p>
                <p>Python Full Stack Web Developer</p>
                <p>Now | <b>Online school Skyeng</b></p>
                <p>English language</p>
                <p><b>Основное образование:</b></p>
                <p>2010 | <b>Российский государственный торгово-экономический университет</b></p>
                <p>Факультет: Коммерция и маркетинг</p>
                <p>Специальность: Коммерция (торговое дело)</p>

                <hr />

                <p><b>Личные интересы: </b>Я увлекаюсь созданием и программированием устройств для умного дома. Это помогает мне развивать свои
                навыки в области программирования и электроники. В свободное время я также изучаю новые технологии и
                языки программирования.</p>
                <hr />
            </div>

            <div className='about_contacts'>
                <ul className="about_contacts">
                    <li><a href="mailto:a.erastov@gmail.com"><b>Написать письмо</b></a></li>
                    <li><a href="https://t.me/Alexey_E_77"><b>Связаться в Telegram</b></a></li>
                    <li><a href="whatsapp://send?phone=79151843530"><b>Связаться по WhatsApp</b></a></li>
                    <li><a href="https://github.com/aerastov"><b>Страница на Github</b></a></li>
                </ul>
            </div>
        </div>
    );
};

export default About
